module.exports = __webpack_public_path__ + "img/zone300400.aa068581.png";